import React from 'react';
import { LegalShell, Section } from '../../components/legal/LegalShell';

const ComplaintsProcedure = () => (
  <LegalShell eyebrow="Legal" title="Complaints Procedure" updated="February 2026">
    <p>Domestic Home Services Limited is committed to providing a high standard of service to all of our customers. If something has gone wrong, we would like the opportunity to put it right.</p>
    <p>This Complaints Procedure explains how to raise a complaint and how we will handle it.</p>

    <Section n="1" title="How to Raise a Complaint">
      <p>You can raise a complaint using any of the methods below. Please provide your plan number (if you have one), a description of your complaint and the outcome you are seeking.</p>
      <p><b>Telephone:</b> 0113 548 7557 (Monday to Friday, 9am to 5pm)<br /><b>Email:</b> hello@domestichomeservices.com<br /><b>Post:</b> Complaints Team, Domestic Home Services Limited, 128 City Road, London, United Kingdom, EC1V 2NX (Registered Office)</p>
    </Section>

    <Section n="2" title="Acknowledgement">
      <p>We aim to acknowledge every complaint within 5 working days of receipt.</p>
    </Section>

    <Section n="3" title="Investigation">
      <p>Your complaint will be reviewed by an appropriate member of our team. We may contact you for further information where needed.</p>
      <p>We aim to provide a full response within 20 working days of acknowledgement. Where a complaint is complex and cannot be resolved within this timeframe, we will keep you updated on progress and provide an expected response date.</p>
    </Section>

    <Section n="4" title="Response">
      <p>Our response will set out our findings, our decision and — where appropriate — any remedy we are offering. If you accept our response the complaint will be closed.</p>
    </Section>

    <Section n="5" title="If You Remain Dissatisfied">
      <p>If you remain dissatisfied following our final response, you may be able to escalate your complaint. Applicable escalation routes will be shared with you in our final response letter or email.</p>
      <p>You may also seek independent advice from Citizens Advice or a similar consumer organisation.</p>
    </Section>

    <Section n="6" title="Vulnerable Customers">
      <p>If you are a vulnerable customer, or if someone is raising a complaint on your behalf, please let us know so that we can offer the appropriate support. See our Vulnerable Customer Policy for more information.</p>
    </Section>

    <Section n="7" title="Records">
      <p>We keep a record of all complaints and their outcomes. Records are handled in accordance with our Privacy Policy and applicable data-protection law.</p>
    </Section>
  </LegalShell>
);

export default ComplaintsProcedure;
